export default {"src":"/_next/static/media/ascdsc.f4d29fda.svg","height":11,"width":20,"blurWidth":0,"blurHeight":0};